export enum MDSLogoKind {
  LogoCircle = "logo-circle",
  LogoRounded = "logo-rounded",
  LogoSquare = "logo-square",
  Lockup = "lockup",
  Wordmark = "wordmark",
  Arrows = "arrows",
  ArrowsCropped = "arrows-cropped",
}

export enum MDSLogoSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
}
